import React, { useEffect } from "react";
// import clsx from "clsx";
import styled from "styled-components";

const Wrapper = styled.div`
  overflow: hidden;
`;
const Cell = styled.div`
  width: 25px;
  height: 25px;
  // background: blue;
  &.bg-gray {
    cursor: pointer;
  }
`;
const HeaderDeco = () => {
  // const grayCell = useRef();
  useEffect(() => {
    // console.time("time is");
    const gray = document.querySelectorAll(".cell .bg-gray")[0];
    if (gray) gray.addEventListener("click", _toggleGrayScale);
    return () => {
      if (gray) gray.removeEventListener("click", _toggleGrayScale);
    };
  }, []);

  const _toggleGrayScale = () => document.body.classList.toggle("grayscale");

  const matrix = [
    "cyan",
    "magenta",
    "yellow",
    "key",
    "gray",
    "gray-100",

    "transparent",

    "cyan",
    "magenta",
    "yellow",
    "key",

    "transparent",
    "transparent",
    "transparent",

    "gray-100",
    "gray",
    "key",

    "transparent",
    "transparent",
    "transparent",
    "transparent",

    "cyan",
    "magenta",
    "yellow",
    "key",
    "gray",
    "gray-100",

    "transparent",

    "cyan",
    "magenta",
    "yellow",
    "key",
    "gray",
    "gray-100",
    "cyan",
    "magenta",
    "yellow",
    "key",
    "gray",
    "gray-100",

    "transparent",

    "cyan",
    "magenta",
    "yellow",
    "key",

    "transparent",
    "transparent",
    "transparent",

    "gray-100",
    "gray",
    "key",

    "transparent",
    "transparent",
    "transparent",
    "transparent",

    "cyan",
    "magenta",
    "yellow",
    "key",
    "gray",
    "gray-100",

    "transparent",

    "cyan",
    "magenta",
    "yellow",
    "key",

    "transparent",
    "transparent",
    "transparent",

    "cyan",
    "magenta",
    "yellow",
    "key",
    "gray",
    "gray-100",
    "cyan",
    "magenta",
    "yellow",
    "key",
    "gray",
    "gray-100",

    "transparent",

    "cyan",
    "magenta",
    "yellow",
    "key",
    "gray",
    "gray-100",

    "transparent",

    "cyan",
    "magenta",
    "yellow",
    "key",

    "cyan",
    "magenta",
    "yellow",
    "key",
    "gray",
    "gray-100",
    "cyan",
    "magenta",
    "yellow",
    "key",
    "gray",
    "gray-100",

    "transparent",

    "cyan",
    "magenta",
    "yellow",
    "key",
    "gray",
    "gray-100",

    "transparent",

    "cyan",
    "magenta",
    "yellow",
    "key",
    "gray",
    "gray-100"
  ];
  return (
    <Wrapper className='header-deco '>
      <ul className='flex '>
        {matrix.map((el, i) => (
          <li key={i}>
            <Cell className='cell'>
              <div className={`w-full h-full bg-${el}`}></div>
            </Cell>
          </li>
        ))}
      </ul>
    </Wrapper>
  );
};

export default HeaderDeco;
/*
cyan
magenta
yellow
key
gray
gray-100

transparent

cyan
magenta
yellow
key
gray
gray-100

transparent
transparent
transparent
transparent

key
gray
gray-100

transparent

cyan
magenta
yellow
key

transparent
transparent
transparent

cyan
magenta
yellow
key
gray
gray-100
cyan
magenta
yellow
key
gray
gray-100

transparent

cyan
magenta
yellow
key
gray
gray-100

transparent

cyan
magenta
yellow
key
gray
gray-100

transparent
transparent
transparent
transparent

key
gray
gray-100

transparent

cyan
magenta
yellow
key

transparent
transparent
transparent

cyan
magenta
yellow
key
gray
gray-100
cyan
magenta
yellow
key
gray
gray-100

transparent

cyan
magenta
yellow
key
gray
gray-100

transparent

cyan
magenta
yellow
key
gray
gray-100
*/
